import React, { Fragment } from 'react';
import { Adjustment, Drawing, Lubricant, Maintenance, Procedure, Tyres } from '..';

interface IProps {
  category: string;
  subCategories: any[];
}

const TechnicalCategoryContent: React.FC<IProps> = ({ subCategories, category }) => {
  return (
    <>
      {subCategories?.map((subCategory: any, index) => {
        switch (category) {
          case 'Adjustments':
            return <Adjustment key={`adjustment${index}`} adjustment={subCategory} />;
          case 'Maintenance':
            return <Maintenance key={`maintenance${index}`} maintenance={subCategory} />;
          case 'Procedures':
            return <Procedure key={`procedure${index}`} procedure={subCategory} />;
          case 'Lubricants':
            return <Lubricant key={`lubricant${index}`} lubricant={subCategory} />;
          case 'Drawings':
            return <Drawing key={`drawing${index}`} drawing={subCategory} />;
          case 'Tyres':
            return <Tyres key={`tyres${index}`} tyres={subCategory} />;
          default:
            return <Fragment key={index} />;
        }
      })}
    </>
  );
};

export default TechnicalCategoryContent;
